import { makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

import { IPackage } from '../../models/IPackage';
import { API_VERSION, PACKAGES_PATH } from '../constants/RestApiConstants';

export interface ISetPackageEnabledRequest {
  packageEnabledRequest: { enabled: boolean };
}

export interface ISetPackageEnabledResponse {
  package?: IPackage;
}

export class SetPackageEnabledService {
  public static setPackageEnabled(
    packageLuid: string,
    enabled: boolean,
  ): Promise<ISetPackageEnabledResponse> {
    return makeJsonRestApiRequest<ISetPackageEnabledRequest, ISetPackageEnabledResponse>({
      config: {
        restApiVersion: API_VERSION,
        httpMethod: 'PUT',
        endpoint: `${PACKAGES_PATH}/${packageLuid}/enabled`,
      },
      request: { packageEnabledRequest: { enabled } },
    });
  }
}
